/* LAYOUT */
export const CHANGE_LAYOUT_WIDTH = "CHANGE_LAYOUT_WIDTH";
export const CHANGE_SIDEBAR_TYPE = "CHANGE_SIDEBAR_TYPE";

// Preloader
export const CHANGE_PRELOADER = "CHANGE_PRELOADER";

